<div class="d-flex">
  <div class="flex-fill"></div>
  <button class="btn btn-secondary-info" (click)="onAdd()">
    <i class="far fa-plus"></i>
    <ng-container i18n>Add Contact</ng-container>
  </button>
</div>

<div class="container-box mt-3" *ngIf="isLoading || !contacts.length">
  <app-loading-section *ngIf="isLoading"></app-loading-section>

  <app-empty-table *ngIf="!isLoading && contacts.length === 0">
    <img class="empty-image" src="assets/images/empty_icons/bdc-contact.svg" />
    <h5 class="empty-header" i18n>Keep Your Property Contacts Organized</h5>
    <p>
      <ng-container i18n
        >Add key contacts for reservations, operations, or support to ensure smooth communication and
        accountability.</ng-container
      >&nbsp; <a href="javascript:void(0)" (click)="onAdd()" i18n>Click here</a>&nbsp;
      <ng-container i18n>to add your first contact and keep everything connected.</ng-container>
    </p>
  </app-empty-table>
</div>

<div class="d-grid gap-3" style="grid-template-columns: repeat(auto-fill, minmax(300px, 350px))">
  <div
    *ngFor="let contact of contacts; let index = index"
    class="container-box p-3 d-flex flex-column gap-2 align-items-center my-3 position-relative"
  >
    <div class="position-absolute d-flex align-items-center gap-2" style="right: 0.25rem; top: 0.25rem">
      <button class="btn btn-light-danger" (click)="onDelete(contact, index)">
        <i class="far fa-trash-alt"></i>
      </button>
      <button class="btn btn-light-info" (click)="onEdit(contact, index)">
        <i class="far fa-edit"></i>
      </button>
    </div>

    <ng-container *ngIf="contact.contact_person as person">
      <app-avatar [text]="person.name" [size]="100"></app-avatar>
      <div class="text-semi-bold text-xl">{{ person.name }}</div>
      <div class="d-flex gap-2 flex-wrap justify-content-center">
        <div class="badge badge-secondary-info badge-pill">{{ person.gender }}</div>
        <div *ngFor="let p of contact.contact_profiles" class="badge badge-secondary-indigo badge-pill">
          {{ p.type | titleCase }}
        </div>
      </div>
      <div>
        <span class="text-semi-bold">Title:</span>&nbsp;
        <span class="text-light">{{ person.job_title }}</span>
      </div>
    </ng-container>
    <div>
      <span class="text-semi-bold">Email:</span>&nbsp;
      <span class="text-light">{{ contact.email }}</span>
    </div>
    <div *ngFor="let phone of contact.phones">
      <span class="text-semi-bold">Mobile:</span>&nbsp;
      <span class="text-light">{{ phone.phone_number }}</span>
    </div>
  </div>
</div>
